export enum SubHeaderTab {
  Data = "Data",
  Documents = "Documents",
  Estate = "Estate",
  Vehicle = "Vehicle",
  Family = "Family",
  Faction = "Faction",
  Business = "Business",
  Skills = "Skills",
  Statistic = "Statistic",
  Basic = "Basic",
  Sound = "Sound",
  Control = "Control",
  Safety = "Safety",
  Gameplay = "Gameplay",
  Chat = "Chat",
}
